module.exports = __webpack_public_path__ + "static/media/education@2x.a7e6e8c9.png";